import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CreatePeriodFormValues } from "./types/types";
import { useCreateReportingPeriodController } from "./useCreateReportingPeriodController";
import { CreatePeriodForm } from "./CreatePeriodForm";
import { cn } from "@/lib/utils";

interface CreateReportingPeriodProps {
  onSubmit: (values: CreatePeriodFormValues) => void;
  trigger?: React.ReactNode;
}

export function CreateReportingPeriod({
  onSubmit,
  trigger,
}: CreateReportingPeriodProps) {
  const controller = useCreateReportingPeriodController({
    onSubmit,
    trigger,
  });

  return (
    <Dialog open={controller.open} onOpenChange={controller.setOpen}>
      <DialogTrigger
        asChild
        className={cn(
          "hidden",
          controller.openReportingPeriods.length !== 0 && "hidden"
        )}
        disabled={controller.openReportingPeriods.length !== 0}
      >
        {controller.trigger || <Button>Add New Period</Button>}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Reporting Period</DialogTitle>
        </DialogHeader>
        <CreatePeriodForm
          formValues={controller.formValues}
          setFormValues={controller.setFormValues}
          onSubmit={controller.onSubmit}
          onCancel={() => controller.setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
